"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyMain = exports.Body = exports.BodyTinyMain = exports.BodyBoldTiny = exports.BodyTinyRegular = exports.BodyTiny = exports.BodySmallMain = exports.BodyBoldSmall = exports.BodySmallRegular = exports.BodySmall = exports.BodyRegularMain = exports.BodyRegular = exports.BodyBoldMicroMain = exports.BodyBoldMicro = exports.BodyMicroMain = exports.BodyMicro = exports.BodyBoldMain = exports.BodyBold = exports.BodySmallBoldMain = exports.SectionTitle = exports.SectionSubTitle = exports.SectionBigTitle = exports.SubHeading = exports.HeadingSmall = exports.Heading = exports.DisplaySmall = exports.DisplayMedium = exports.DisplayLarge = exports.DisplayXLarge = exports.MegaTitleText = exports.BigTitleText = exports.TitleText = exports.SubtitleText = exports.RegularText = exports.SmallText = exports.BaseText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.BaseText = styled_components_1.default.p `
  color: ${(props) => props.color || props.theme.colors.text.body};
`;
/** @deprecated */
exports.SmallText = (0, styled_components_1.default)(exports.BaseText) `
  font-family: ${({ theme }) => theme.fontFamily.text};
  font-size: 0.75rem;
  font-weight: normal;
  line-height: 1.125rem;
`;
/** @deprecated */
exports.RegularText = (0, styled_components_1.default)(exports.BaseText) `
  font-family: ${({ theme }) => theme.fontFamily.text};
  font-size: 0.875rem;
  font-weight: normal;
  line-height: 1.25rem;
`;
/** @deprecated */
exports.SubtitleText = (0, styled_components_1.default)(exports.BaseText) `
  font-family: ${({ theme }) => theme.fontFamily.title};
  font-size: 1rem;
  font-weight: normal;
  line-height: 1.3rem;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    font-size: 1.125rem;
    line-height: 1.625rem;
  }
`;
/** @deprecated */
exports.TitleText = (0, styled_components_1.default)(exports.BaseText) `
  font-family: ${({ theme }) => theme.fontFamily.title};
  font-size: 1.25rem;
  font-weight: normal;
  line-height: 1.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    font-size: 1.5rem;
    line-height: 1.875rem;
  }
`;
/** @deprecated */
exports.BigTitleText = (0, styled_components_1.default)(exports.BaseText) `
  font-family: ${({ theme }) => theme.fontFamily.title};
  font-size: 1.7rem;
  font-weight: normal;
  line-height: 2rem;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    font-size: 2rem;
    line-height: 2rem;
  }
`;
/** @deprecated */
exports.MegaTitleText = (0, styled_components_1.default)(exports.BaseText) `
  font-family: ${({ theme }) => theme.fontFamily.title};
  font-size: 2.2rem;
  font-weight: normal;
  line-height: 2.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    font-size: 2.625rem;
    line-height: 2.625rem;
  }
`;
exports.DisplayXLarge = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.display.x_large);
exports.DisplayLarge = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.display.large);
exports.DisplayMedium = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.display.medium);
exports.DisplaySmall = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.display.small);
exports.Heading = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.heading.heading);
exports.HeadingSmall = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.heading.small);
exports.SubHeading = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.heading.subheading);
exports.SectionBigTitle = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.section.bigTitle);
exports.SectionSubTitle = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.section.subtitle);
exports.SectionTitle = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.section.title);
exports.BodySmallBoldMain = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.body.boldSmallTextMain);
exports.BodyBold = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.body.boldText);
exports.BodyBoldMain = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.body.boldTextMain);
exports.BodyMicro = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.body.microText);
exports.BodyMicroMain = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.body.microTextMain);
exports.BodyBoldMicro = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.body.boldMicroText);
exports.BodyBoldMicroMain = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.body.boldMicroTextMain);
exports.BodyRegular = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.body.regularText);
exports.BodyRegularMain = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.body.regularTextMain);
exports.BodySmall = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.body.smallText);
exports.BodySmallRegular = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.body.smallTextRegular);
exports.BodyBoldSmall = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.body.boldSmallText);
exports.BodySmallMain = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.body.smallTextMain);
exports.BodyTiny = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.body.tinyText);
exports.BodyTinyRegular = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.body.tinyTextRegular);
exports.BodyBoldTiny = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.body.boldTinyText);
exports.BodyTinyMain = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.body.tinyTextMain);
exports.Body = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.body.text);
exports.BodyMain = (0, styled_components_1.default)(exports.BaseText)(({ theme }) => theme.typography.body.textMain);
